import Component from './md-editor.vue';
export default Component;
